import React from 'react';
import { motion } from 'framer-motion';
import { frameworkStages } from '../../lib/constants';

const Framework = () => {
  return (
    <section className="py-16 md:py-24 bg-neutral-950 text-white relative overflow-hidden">
      <motion.div
        className="absolute inset-0 opacity-20"
        animate={{
          background: [
            'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 80% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
          ]
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: "linear"
        }}
      />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <motion.div
          className="text-center mb-12 md:mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 md:mb-4">
            The Arabica Framework
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-neutral-400">
            A proprietary approach to design that moves as fast as your startup
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 md:gap-16 items-center">
          <motion.div className="relative">
            <div className="relative">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
                {frameworkStages.map((stage, index) => (
                  <motion.div
                    key={index}
                    className="relative"
                    initial={{ opacity: 0, scale: 0 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: index * 0.2 }}
                    viewport={{ once: true }}
                  >
                    <div className="bg-white/5 border border-white/10 rounded-2xl p-5 md:p-6 text-center backdrop-blur-sm hover:bg-white/10 transition-all h-full flex flex-col">
                      <div className="w-10 h-10 md:w-12 md:h-12 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4 backdrop-blur-sm border border-white/10">
                        <span className="font-bold text-lg md:text-xl">{index + 1}</span>
                      </div>
                      <h4 className="font-bold text-base md:text-lg mb-2">
                        {stage.name}
                      </h4>
                      <p className="text-sm text-neutral-400 leading-relaxed">
                        {stage.description}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-base md:text-lg text-neutral-300 leading-relaxed mb-6 md:mb-8">
              Developed over 10+ years of working with high-growth startups, the Arabica Framework ensures design decisions are data-driven, conversion-focused, and delivered at startup speed. Weekly deliverables mean you never wait - you move.
            </p>
            <p className="text-base md:text-lg text-neutral-300 leading-relaxed">
              We skip the bloat of traditional agencies and focus purely on what drives your metrics: rapid iteration, user testing, and scalable systems.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Framework;